// jshint esversion: 8
import ApiFactory from '@/api/ApiFactory';
const AmenitiesApi = ApiFactory.get('amenities');
const fetchAll = async ( { commit }, qs ) => {
  const { data } = await AmenitiesApi.getAll(qs);
  commit("SET_DATA", data);
};

export default {
  fetchAll
};
